type OfferReviewProspectAddressFields = {
  customerStreet?: string;
  customerCity?: string;
  customerState?: string;
  customerZipCode?: string;
};

const formatOfferReviewProspectAddress = (
  prospect: OfferReviewProspectAddressFields | undefined
): string | undefined => {
  if (!prospect) {
    return undefined;
  }

  const stateZip = [prospect.customerState, prospect.customerZipCode]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(" ");

  const parts = [prospect.customerStreet, prospect.customerCity, stateZip]
    .map((part) => part?.trim())
    .filter(Boolean);

  return parts.length > 0 ? parts.join(", ") : undefined;
};

export { formatOfferReviewProspectAddress };
export type { OfferReviewProspectAddressFields };
